var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudArrowUp64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 46.5h-11c-6.075 0-11-4.925-11-11s4.925-11 11-11l.33.005C15.464 15.959 22.978 9.5 32 9.5c9.023 0 16.537 6.459 18.17 15.005l.33-.005c6.075 0 11 4.925 11 11 0 5.979-4.77 10.843-10.712 10.996l-.288.004h-11",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 46.5c-6.075 0-11-4.925-11-11s4.925-11 11-11l.33.005C15.464 15.959 22.978 9.5 32 9.5c9.023 0 16.537 6.459 18.17 15.005l.33-.005c6.075 0 11 4.925 11 11 0 5.979-4.77 10.843-10.712 10.996l-.288.004h-37z",
    fillOpacity: 0.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M32 29v30.5m-7-24l7-7 7 7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowUp64);
export default __webpack_public_path__ + "static/media/cloud-arrow-up-64.f1182a4d.svg";
export { ForwardRef as ReactComponent };